const AdviserExportIntegrationTypeEnum = Object.freeze({
    SPRINT_IO: 'SPRINT_IO',
    IRESS_XPLAN: 'IRESS_XPLAN'
});

export default AdviserExportIntegrationTypeEnum;
